import type { ComponentType } from 'react';

/*
  Рабочее пространство оболочки Kaname: вкладки открытых объектов (уровень навигации 3) и окна.

  Основное окно всегда начинается со вкладки вида — это «где я в меню» (раздел и вид модуля).
  Меню и подменю меняют именно её; объекты (аккаунт, упоминание, задача) открываются своими
  вкладками справа от неё. Второе окно появляется, когда объект открывают рядом, и держит
  только объекты. Адрес в браузере — это активная вкладка окна, в котором сейчас работают.
*/

export type PaneId = 'main' | 'side';

/** Иконка вкладки и пунктов меню. */
export type ShellIcon = ComponentType<{ className?: string }>;

/** Что известно об адресе: вид модуля (живёт во вкладке вида) или объект (своя вкладка). */
export interface ResolvedPath {
  type: 'view' | 'object';
  /** Сервис, к которому относится адрес: по нему подсвечиваются меню и подменю. */
  serviceId: string;
  title: string;
  icon: ShellIcon;
  /** Полный путь для подсказки вкладки и заголовка окна: «Хостинг › Аккаунты › example.ru». */
  trail?: string;
  /** У объекта — вид, к которому он относится: в подменю на нём остаётся след. */
  homeView?: string;
}

export type PathResolver = (path: string) => ResolvedPath;

export interface WorkspaceTab {
  id: string;
  path: string;
  title: string;
  pinned: boolean;
}

export interface PaneState {
  /** Открытые объекты по порядку; закреплённые всегда первыми. */
  tabs: string[];
  /** Активная вкладка: id объекта или VIEW_TAB (только у основного окна). */
  active: string;
}

export interface WorkspaceState {
  /** Адрес вида во вкладке вида основного окна. */
  view: string;
  tabs: Record<string, WorkspaceTab>;
  main: PaneState;
  side: PaneState | null;
  focused: PaneId;
  /** Доля основного окна по ширине, когда окон два. */
  split: number;
}

export const VIEW_TAB = 'view';

/** Вкладка упала: её поймала своя граница ошибок, остальные работают (R42). */
export interface TabCrash {
  pane: PaneId;
  /** id вкладки; VIEW_TAB — вкладка вида. */
  id: string;
  path: string;
  error: Error;
}
